export type VenueTypeSelected = { venueTypeName: string };
export type VenueSelected = { venueTypeName: string; venueName: string };

export type VenueAnalysisSelection = VenueTypeSelected | VenueSelected;

export function isVenueSelected(
    selection?: VenueAnalysisSelection
): selection is VenueSelected {
    return !!(selection && (selection as VenueSelected).venueName);
}
